import React, { Component } from 'react';
import Icon from './icon';

export default class IconList extends Component {
  render() {
    const { data, grid, ...props } = this.props;
    return (
      <ul className="listing-facts">
        {Object.keys(data).map(key => (
          <Icon key={key} type={key} value={data[key]} {...props} grid={grid} />
        ))}
      </ul>
    );
  }
}
